import { UploadOutlined } from '@ant-design/icons';
import { FormHandler, FormItem, RadioGroupInput } from '@framework/form';
import { ModalDialog } from '@framework/ui';
import { Button, Tooltip } from 'antd';
import * as React from 'react';
import { useMemo, useState } from 'react';
import { Subject } from 'rxjs';
import { MapSubjectEvent } from '../../MapWidgetComponent';
import { MapUploadGeometriesGeoJSONInput } from './MapUploadGeometriesGeoJSONInput';
import { MapUploadGeometriesSchema } from './MapUploadGeometriesSchema';
import { MapUploadGeometriesShapefileInput } from './MapUploadGeometriesShapefileInput';

export interface IMapUploadGeometriesControlProps {
  mapSubject: React.RefObject<Subject<MapSubjectEvent>>;
}

export function MapUploadGeometriesControl(
  props: IMapUploadGeometriesControlProps,
) {
  const { mapSubject } = props;

  const [isOpen, setIsOpen] = useState(false);

  const initialValues = useMemo(() => {
    return MapUploadGeometriesSchema.cast({}, { assert: false });
  }, []);

  return (
    <div>
      <Tooltip title="Carica geometrie da file GeoJSON o Shapefile">
        <Button
          type="default"
          style={{ borderWidth: '1px' }}
          onClick={() => setIsOpen(true)}
          icon={
            <UploadOutlined aria-label="Carica geometrie da file GeoJSON o Shapefile" />
          }
        />
      </Tooltip>
      <ModalDialog
        title="Carica Geometrie"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        size="small"
        onOk={() => setIsOpen(false)}
      >
        <div>
          <FormHandler
            nested
            schema={MapUploadGeometriesSchema}
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <FormItem
              name="type"
              label="Tipo di geometria"
              layout={{ hideVisualLabel: true }}
            >
              <RadioGroupInput
                name="type"
                buttonStyle="solid"
                optionType="button"
                options={[
                  { label: 'GeoJSON', value: 'geojson' },
                  { label: 'Shapefile', value: 'shapefile' },
                ]}
              />
            </FormItem>

            <MapUploadGeometriesGeoJSONInput
              mapSubject={mapSubject}
              onClose={() => setIsOpen(false)}
            />

            <MapUploadGeometriesShapefileInput
              mapSubject={mapSubject}
              onClose={() => setIsOpen(false)}
            />
          </FormHandler>
        </div>
      </ModalDialog>
    </div>
  );
}
